import { FeeSource, type SystemFeesPayload } from '@ankor-io/common/types/pay/fee'
import { Field, Heading, Input, Label, Loading } from '@ankor-io/ui-components'

import { MIN_LOADING_DISPLAY_MS } from '@/constants/ui'
import { useMinimumDisplayTime } from '@/hooks/useMinimumDisplayTime'

export type SystemPricingProps = {
  systemFees: SystemFeesPayload | undefined
  isError: boolean
  isPending: boolean
  error: Error | null
}
export function SystemPricing({ isError, isPending, systemFees }: SystemPricingProps) {
  const showLoader = useMinimumDisplayTime(isPending, MIN_LOADING_DISPLAY_MS)

  // Error toast is handled globally by QueryProvider
  // Component still handles error UI state (returns null on error)

  if (isError) {
    return null
  }
  if (isPending) {
    return showLoader ? <Loading variant="spinner" /> : null
  }
  if (!systemFees) {
    return null
  }

  const renderForm = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 w-full flex-1">
              <Field>
                <Label>Conversion Fee (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={systemFees.fees.find((fee) => fee.feeSource === FeeSource.CONVERSION)?.feeAmount ?? 0}
                  disabled
                />
              </Field>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 w-full flex-1">
              <Field>
                <Label>Transfer Fee (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={systemFees.fees.find((fee) => fee.feeSource === FeeSource.TRANSFER)?.feeAmount ?? 0}
                  disabled
                />
              </Field>
            </div>
          </div>
          {/* <div className="flex justify-end">
            <Button
              type="submit"
              disabled
            >
              Save Changes
            </Button>
          </div> */}
        </div>
      </form>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-1 p-4 rounded-md border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between p-4 ">
          <div className="flex flex-col gap-1">
            <Heading level={2}>System Pricing</Heading>
            <p className="text-sm text-gray-600 dark:text-gray-400">Manage the fees for your organization</p>
          </div>
        </div>
        <div className="space-y-6 px-4 pb-4">{renderForm()}</div>
      </div>
    </div>
  )
}
